module.exports = __webpack_public_path__ + "media/scholarships/no_new_matches_sprite_2-84aaeafc.png";